module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('h1', [_vm._v("Foto's")]), _vm._v(" "), _c('imageUploader'), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, [_vm._l((_vm.media), function(m, id) {
    return (!m.processed && !m.error) ? _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-body"
    }, [_c('div', {
      staticClass: "spinner-container"
    }, [_c('svg', {
      staticClass: "spinner spinner-dark",
      attrs: {
        "viewBox": "0 0 50 50"
      }
    }, [_c('circle', {
      staticClass: "path",
      attrs: {
        "cx": "25",
        "cy": "25",
        "r": "20",
        "fill": "none",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-card-badge uk-label",
      class: 'uk-label-danger',
      on: {
        "click": function($event) {
          _vm.deleteProcessingImage(id)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.media), function(m, id) {
    return (m.processed & !m.error) ? _c('div', [_c('a', {
      attrs: {
        "href": "#image-edit",
        "uk-toggle": ""
      },
      on: {
        "click": function($event) {
          _vm.select(id)
        }
      }
    }, [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": m.small,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-card-badge uk-label",
      class: (m.placeholder && m.small && m.medium && m.large && m.extralarge) ? 'uk-label-success' : 'uk-label-danger'
    }, [_c('span', {
      attrs: {
        "uk-icon": "check"
      }
    })])])])]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "image-edit",
      "uk-modal": ""
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('div', {
    staticClass: "uk-align-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.media[_vm.selected].small
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [(_vm.$store.state.core.user.role >= 3) ? _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteImage(_vm.selected)
      }
    }
  }, [_vm._v("Verwijderen")]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Afbeelding bewerken")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfda8c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/MEDIA/Overview.vue
// module id = 524
// module chunks = 1